export const obscure = (value: string): string => {
  return value.slice(0, 3) + value.slice(-2).padStart(8, '*')
}
